<template>
  <v-container class="grey lighten-5">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <div id="uno" v-if="permisorunning">
          <div class="text-center">
            <h2>SOLICITUD ACTUAL</h2>
            <br />
          </div>

          <v-card :elevation="4" class="pa-2">
            <div>
              <v-simple-table v-if="domicilios && domicilios">
                <template v-slot:default >
                  <thead>
                    <tr>
                      <th class="text-left">Cargo que autoriza el permiso</th>
                      <th class="text-left">Tipo Permiso</th>
                      <th class="text-left">Motivo del Permiso</th>
                      <th class="text-left">Fecha de solicitud</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in solicitudArray" :key="data.autorizador">
                      <td>{{ data.autorizador }}</td>
                      <td>{{ data.tipopermiso }}</td>
                      <td>{{ data.motivopermiso }}</td>
                      <td>{{ data.fechaSolicitud }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>


          <v-btn block color="success" @click="deleteSolicitudDomicilio" v-if="!domicilios"
              >ELIMINAR DOMICILIO SOLICITUD</v-btn
            >
            <v-alert type="error" v-if="statusFailure">
            {{ mensaje }}
          </v-alert>


          </v-card>
        </div>

        <div id="dos" v-if="!permisorunning">
          <div class="text-center">
            <h2>FORMULARIO DE SOLICITUD</h2>
            <br />
          </div>

          <v-card :elevation="4" class="pa-2">
            <div class="text-center">
              <form>
                <v-checkbox
                  v-model="esdomicilio"
                  label="DOMICILIO"
                  value="none"
                ></v-checkbox>

                <v-checkbox
                  v-model="fueradesitio"
                  label="SOLICITAR PERMISO FUERA DE SITIO"
                  value="none"
                ></v-checkbox>

                <v-select
                  v-model="select1"
                  :items="autorizadores"
                  item-text="nombre"
                  item-value="id"
                  label="Persona que autoriza el permiso"
                  required
                  v-if="!esdomicilio"
                ></v-select>
                <v-select
                  v-model="select2"
                  :items="tipopermiso"
                  item-text="nombre"
                  item-value="id"
                  label="Tipo de permiso"
                  required
                  v-if="!esdomicilio"
                ></v-select>
                <v-select
                  v-model="select3"
                  :items="motivopermiso"
                  item-text="nombre"
                  item-value="id"
                  label="Motivo del permiso"
                  required
                  v-if="!esdomicilio"
                ></v-select>

                <v-date-picker
                  v-model="date"
                  no-title
                  @input="menu1 = false"
                  locale="es"
                  v-if="!esdomicilio"
                ></v-date-picker>

                <v-text-field
                  v-model="fecha"
                  :counter="10"
                  required
                  v-if="!esdomicilio"
                ></v-text-field>

                <v-time-picker v-model="e4" v-if="!esdomicilio"></v-time-picker>

                <v-text-field
                  v-model="hora"
                  :counter="10"
                  required
                  v-if="!esdomicilio"
                ></v-text-field>

                <v-card v-if="esdomicilio">
                  <v-card-title>
                    <div></div>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi.file-search-outline"
                      label="Buscar"
                      single-line
                      hide-details
                      @keypress="filter"
                    ></v-text-field>
                  </v-card-title>

                  <v-data-table
                    v-model="select1"
                    :headers="headers"
                    :items="tabla"
                    :single-select="true"
                    item-key="id"
                    show-select
                    class="elevation-1"
                  >
                  </v-data-table>

                  <div class="text-center pt-2">
                    <v-pagination
                      v-model="page"
                      :length="pageCount"
                      @input="onPageChange"
                    ></v-pagination>

                    <br /><br />
                  </div>

                  <v-text-field
                    v-model="valordo"
                    append-icon="mdi.file-search-outline"
                    label="Valor domicilio"
                  ></v-text-field>
                  <v-btn block color="success" @click="agregarItems"
                    >AGREGAR</v-btn
                  ><br />

                  <v-data-table
                    v-model="select4"
                    :headers="headers2"
                    :items="tabla2"
                    :single-select="singleSelect"
                    item-key="id"
                    show-select
                    class="elevation-1"
                  >
                  </v-data-table>

                  <template v-slot:top>
                    <v-switch
                      v-model="singleSelect"
                      label="Seleccion individual"
                      class="pa-3"
                    ></v-switch>
                  </template>

                  <v-btn block color="success" @click="removerItems"
                    >REMOVER</v-btn
                  ><br />
                </v-card>

                <v-col cols="12" md="12">
                  <v-textarea solo v-model="nota" label="Nota:"></v-textarea>
                </v-col>
              </form>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <div id="TRES" v-if="permisorunning && domicilios">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card :elevation="4" class="pa-2">
            <v-btn block color="success" @click="deleteSolicitud"
              >ELIMINAR SOLICITUD</v-btn
            >
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div id="dos" v-if="!permisorunning">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card :elevation="4" class="pa-2">
            <v-btn block color="success" @click="finish">ENVIAR</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="8" lg="6">
        <div class="text-center">
          <v-progress-circular
            v-if="statusLoader"
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>

          <v-alert type="success" v-if="statusCreated">
            SOLICITUD GRABADA
          </v-alert>

          <v-alert type="error" v-if="statusFailure">
            {{ mensaje }}
          </v-alert>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { actionStore } from "../../components/CheckerLocalStorage.js";

export default {
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    e4: null,
    dropdown_font: ["Arial", "Calibri", "Courier", "Verdana"],

    fecha: "",
    autorizadores: [{ id: 1, nombrePerfilCargo: "one" }],
    tipopermiso: [{ id: 1, nombrePerfilCargo: "one" }],
    motivopermiso: [{ id: 1, nombrePerfilCargo: "one" }],
    nota: "",
    select1: [],
    domicilios:true,
    select2: null,
    select3: null,
    select4: [],
    hora: "",
    url1: "",
    url2: "",
    url3: "",
    url4: "",
    idUser: "",
    fueradesitio:false,
    solicitudArray: [],
    esdomicilio: false,
    search: "",
    cantidaddo: 0,
    valordo: 0,
    singleSelect: false,

    permisorunning: false,
    statusLoader: false,
    statusFailure: false,
    statusCreated: false,
    mensaje: "No se pudo grabar la solicitud",
    idsolicitud: "",
    fechaSolicitud: "",
    //*******TABLE PAGINATION */
    page: 0,
    pageCount: 0,
    itemsPerPage: 10,
    headers: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id"
      },
      { text: "barrio", value: "nombre" }
    ],
    tabla: [],

    //*******TABLE PAGINATION */

    //*******TABLE PAGINATION */

    headers2: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id"
      },
      { text: "ID BARRIO", value: "id2" },
      { text: "VALOR DOMICILIO", value: "valor" },
      { text: "BARRIO", value: "nombre" }
    ],
    tabla2: []

    //*******TABLE PAGINATION */
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      this.fecha = "Fecha seleccionada: " + this.dateFormatted;
    },
    e4(val) {
      this.hora = "Hora seleccionada: " + this.e4;
      console.log("it has cahnged.." + this.e4);
    }
  },

  beforeMount() {
    let that = this;
    this.url4 =
      actionStore.methods.getInfoEmpresa().urlServer +
      "/register/traepermisoindividual/" +
      actionStore.methods.getInfoEmpresa().usuarioTenantid +
      "?tenantId=tenantId" +
      actionStore.methods.getInfoEmpresa().tenantId;
    console.log(this.url4);

    this.url1 =
      actionStore.methods.getInfoEmpresa().urlServer +
      "/register/autorizadorespermisos?tenantId=tenantId" +
      actionStore.methods.getInfoEmpresa().tenantId;
    this.url2 =
      actionStore.methods.getInfoEmpresa().urlServer +
      "/register/tipopermiso?tenantId=tenantId" +
      actionStore.methods.getInfoEmpresa().tenantId;
    this.url3 =
      actionStore.methods.getInfoEmpresa().urlServer +
      "/register/motivopermiso?tenantId=tenantId" +
      actionStore.methods.getInfoEmpresa().tenantId;
    this.idUser = actionStore.methods.getInfoEmpresa().usuarioTenantid;

    axios
      .get( actionStore.methods.getInfoEmpresa().urlServer +
      "/register/getdomicilio/"+this.idUser+"?tenantId=tenantId" +
      actionStore.methods.getInfoEmpresa().tenantId)
      .then(function(response) {
        


      })
      .then().catch(function(error) {
            if (error.response.status == 400) {
              that.permisorunning = true;
              that.domicilios = false;
            }
          });


  },

  mounted() {
    let that = this;

    this.deployingSolicitudes();

    axios
      .get(this.url1)
      .then(function(response) {
        //  console.log(response);
        that.autorizadores = response.data;
      })
      .then();

    axios
      .get(this.url2)
      .then(function(response) {
        //  console.log(response);
        that.tipopermiso = response.data;
      })
      .then();

    axios
      .get(this.url3)
      .then(function(response2) {
        console.log(response2);
        that.motivopermiso = response2.data;
      })
      .then();

    axios
      .get(
        actionStore.methods.getInfoEmpresa().urlServer +
          "/register/barrios/0/" +
          "-" +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId
      )
      .then(function(response) {
        //console.log(response);
        that.pageCount = parseInt(response.data.totalPages);
        that.tabla = response.data.infoBarrio;
      })
      .then();

    //this.fillTable();
  },

  methods: {
    deployingSolicitudes: function() {


      if(this.esdomicilio){




      }else{

        let that = this;

        axios
          .get(this.url4)
          .then(function(response) {
            that.permisorunning = true;
            that.solicitudArray.push(response.data);
            that.idsolicitud = response.data.id;
            that.fechaSolicitud = response.data.fechaSolicitud;
            console.log(response);
          })
          .then()
          .catch(function(error) {
            if (error.response.status == 404) {
              //that.permisorunning = true;
            }
          });

      }

      
    },

    appendLeadingZeroes: function(n) {
      if (n <= 9) {
        return "0" + n;
      }
      return n;
    },

    agregarItems: function() {
      if (isNaN(this.valordo)) {
        alert("Solo ingrese numeros");
      } else {
        this.select1.map(item => {
          let value = {
            id: this.tabla2.length,
            id2: item.id,
            valor: this.valordo,
            nombre: item.nombre
          };
          this.tabla2.push(value);
        });
      }
    },

    removerItems: function() {
      let array = [];
      this.select4.map(item => {
        var index = this.tabla2.indexOf(item);
        if (index > -1) {
          this.tabla2.splice(index, 1);
        }
      });
    },

  deleteSolicitudDomicilio: function(){

     let that = this;
     axios
          .post(actionStore.methods.getInfoEmpresa().urlServer +
          "/register/deletingpermisodomiclio/" +
          this.idUser +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId, {})
          .then(function(response) {
            
            if(response.status==201){

                console.log("IT CANNOT BE DELETED");

                that.mensaje = "LA SOLICITUD NO PUEDE SER ELIMINADA";

                that.statusFailure = true;
            }

          })
          .catch(function(error) {
           if (error.response.status == 400) {
              


             that.removingDomicilio();


            }
          });

  },


  removingDomicilio: function(){

     let that = this;
     axios
          .post(actionStore.methods.getInfoEmpresa().urlServer +
          "/register/deleteonceforall/" +
          this.idUser +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId, {})
          .then(function(response) {
            
            if(response.status==201){

                that.mensaje = "";

                that.statusFailure = false;
                that.permisorunning = false;
            }

          })
          .catch(function(error) {
           
          });

  },

    deleteSolicitud: function() {
      let current_datetime = new Date();

      let formatted_date =
        current_datetime.getFullYear() +
        "-" +
        this.appendLeadingZeroes(current_datetime.getMonth() + 1) +
        "-" +
        this.appendLeadingZeroes(current_datetime.getDate()) +
        " " +
        this.appendLeadingZeroes(current_datetime.getHours()) +
        ":" +
        this.appendLeadingZeroes(current_datetime.getMinutes()) +
        ":" +
        this.appendLeadingZeroes(current_datetime.getSeconds());

      console.log("javascript " + formatted_date);

      console.log("db " + this.fechaSolicitud);

      if (formatted_date < this.fechaSolicitud) {
        this.statusLoader = true;
        let url =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/deletingpermiso/" +
          this.idsolicitud +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        let that = this;
        console.log(url);
        axios
          .post(url, {})
          .then(function(response) {
            that.statusLoader = false;
            that.permisorunning = false;
            that.solicitudArray = [];
          })
          .catch(function(error) {
            console.log("finalizacion...");
            console.log(error);
          });
      } else {
        this.statusFailure = true;
        this.mensaje = "La solicitud no puede ser eliminada";
      }

      /*
       */
    },

    filter: function() {
      let that = this;
      let temporalSearch = "";
      if (this.search == "") {
        temporalSearch = "-";
      } else {
        temporalSearch = this.search;
      }

      console.log(
        actionStore.methods.getInfoEmpresa().urlServer +
          "/register/barrios/" +
          this.page +
          "/" +
          temporalSearch +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId
      );
      axios
        .get(
          actionStore.methods.getInfoEmpresa().urlServer +
            "/register/barrios/" +
            this.page +
            "/" +
            temporalSearch +
            "?tenantId=tenantId" +
            actionStore.methods.getInfoEmpresa().tenantId
        )
        .then(function(response) {
          //console.log(response);
          that.pageCount = parseInt(response.data.totalPages);
          that.tabla = response.data.infoBarrio;
        })
        .then();
      //}

      console.log("we are ready to display..");
    },

    finish: function() {
      if (this.esdomicilio) {


        if(this.tabla2.length>0){


          let domiciliosDetalle = [];
        let valor = 0;
        this.tabla2.map(item => {
          domiciliosDetalle.push({ fkIdBarrio: item.id2, valor: item.valor });
          valor = valor + parseInt(item.valor);
        });

        let dataToSend = {
          fkIdSede: "",
          fkIdUsuario: this.idUser,
          cantidadDomicilios: domiciliosDetalle.length,
          valorDomicilios: valor,
          fecha: "2020-02-12",
          fechaHOraSalida: "",
          domiciliosDetale: domiciliosDetalle
        };

        console.log(dataToSend);

        let that = this;
        let url =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/createdomicilio?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        axios
          .post(url, dataToSend)
          .then(function(response) {
            console.log(response);
            console.log("sucess");
            that.deployingSolicitudes();
              var delayInMilliseconds = 2000; //1 second

              setTimeout(function() {
                that.statusLoader = false;
                //that.statusCreated=true;
                that.permisorunning = true;
              }, delayInMilliseconds);
          })
          .catch(function(error) {
            console.log("from error...");
            console.log(error.message);
            that.statusLoader = false;

            if (error.response.status == 421) {
              that.mensaje =
                "No puede tener varias solicitudes, elimine la anterior y cree una nueva.";
              that.statusFailure = true;
            }
          });


        }else{


          alert("Seleccione un lugar de destino y el valor del domicilio");

        }

        
      } else {
        this.statusLoader = true;
        this.statusFailure = false;
        this.statusCreated = false;
        console.log("from here.." + this.dateFormatted);
        console.log("from here.." + this.e4);

        if (this.select1 != "" && this.select2 != "" && this.select2 != "") {
          console.log("s1 " + this.select1);
          console.log("s2 " + this.select2);
          console.log("s3 " + this.select3);

          let that = this;
          let url =
            actionStore.methods.getInfoEmpresa().urlServer +
            "/register/permision/"+this.fueradesitio+"?tenantId=tenantId" +
            actionStore.methods.getInfoEmpresa().tenantId;
          axios
            .post(url, {
              fk_id_usuario: that.idUser,
              fk_id_personal_que_autoriza_permisos: that.select1,
              fk_id_permiso: that.select2,
              fk_id_motivo_permiso: that.select3,
              fecha_hora_solicitud_permiso:
                that.dateFormatted + " " + that.e4 + ":00",
              fecha_solicitud_permiso: that.dateFormatted,
              nota: that.nota
            })
            .then(function(response) {
              console.log(response);
              console.log("sucess");
              that.deployingSolicitudes();
              var delayInMilliseconds = 2000; //1 second

              setTimeout(function() {
                that.statusLoader = false;
                //that.statusCreated=true;
                that.permisorunning = true;
              }, delayInMilliseconds);
            })
            .catch(function(error) {
              console.log("from error...");
              console.log(error.message);
              that.statusLoader = false;

              if (error.response.status == 421) {
                that.mensaje =
                  "No puede tener varias solicitudes, elimine la anterior y cree una nueva.";
                that.statusFailure = true;
              }
            });
        }
      }
    },

    onPageChange: function() {
      this.filter();
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>
